export const formatErrorMessage = (message: string) => {
  const formatted = message.replace(/_/g, " ");
  return formatted.charAt(0).toUpperCase() + formatted.slice(1);
};
